<script lang="ts" setup>

import baseSyncSchedule from "@/components/baseSyncSchedule.vue";
import {} from "./ChartBaseStatic";
import AUApi from "@/api";
import { ref, onMounted } from "vue";
import { AufgabeChartParams } from "../ChartTypesAndFunctions";
import { getKZAufgabeDefiniton } from "@/CalcHelperStatic";
const props = defineProps<{
  query?: string;
  height?: number;
  druckItems?: ALLDruck[];
  params: AufgabeChartParams;
}>();

let initialized = ref<boolean>(false);
let editorComponent: string = "RkMitarbeiterTemplateDialogReisen"; // TODO weghauen - is nur annahme
let formular: ALLFrame; // TODO weghauen - is nur annahme
let aufgabenDefinition = props.params.aufgabenDefinition;
let druckItemsLocal: ALLDruck[];
let data: QueryResponse;
let group: any = {};
onMounted(async () => {
  if (!props.params.aicStamm || !aufgabenDefinition) {
    console.log("no query given for ui");
    return;
  }

  let resp = await AUApi.Current.getQuery(props.query ?? props.params.query);
  data = resp.data;

  editorComponent = getKZAufgabeDefiniton("editorComponent", null, data);
  formular = getKZAufgabeDefiniton("formular", null, data);
  druckItemsLocal =
    (props.params.zuordnungen?.filter(
      (z) => z.gruppe === "Druck"
    ) as ALLDruck[]) ?? props.druckItems;

  initialized.value = true;
});
</script>
<template>
  <baseSyncSchedule
    v-if="initialized"
    ref="schedule"
    :query="params.query"
    :editorComponent="editorComponent"
    currentView="Month"
    :showMonth="true"
    :showGroup="false"
    :formular="formular"
    :groupUebergabe="group"
    :persistence="false"
    :useCellTemplate="false"
    :showWeek="false"
    :reloadGroup="false"
    :showICS="false"
    :dienstplan="false"
    :showQuickInfo="false"
    :abteilung="false"
    :onlyEdit="true"
    queryMitarbeiter=""
    :readOnly="false"
  />
</template>
